import React, { useMemo, useRef } from 'react'
import NodeModalAutoMapperV2 from '../../../components/react-flow/auto-mapper-v2/auto-mapper/NodeModal_AutoMapperV2'
import { LLM_MAPPER_V2 } from '../../../utils/NodeModalContants';

function AutoMapperV2({ dataModelformField, setDataModelformField, attributes }) {
    const autoMapperNodeId = useRef(`dndnode_${+new Date()}`).current;

    const commonProps = useMemo(() => ({
        open: true,
        handleClose: () => { },
        nodeId: autoMapperNodeId,
        nodeName: LLM_MAPPER_V2.nodeModalTitle,
        nodes: {},
        edges: [],
        changeNodeName: () => { },
        setNodes: () => { },
        dataModel: true,
        dataModelformField,
        setDataModelformField,
        attributes
    }), [
        autoMapperNodeId,
        dataModelformField,
        attributes
    ]);

    return (
        <div>
            <strong>Auto Mapper V2</strong>
            <NodeModalAutoMapperV2 {...commonProps} />
        </div>
    )
}

export default React.memo(AutoMapperV2);